import BulkUploadFile from './bulkuploadfile.svg'
import AddressProofIcon from './addressProof.svg'
import ChequeIcon from './chequeIcon.svg'
import PanIcon from './panIcon.svg'
import PassportIcon from './passportIcon.svg'
import EducationIcon from './educationIcon.svg'
import ActiveIcon from './active.svg'
import CompletedIcon from './completed.svg'
import RejectedIcon from './rejected.svg'
import CorrectIcon from './correct.png'
import PendingIcon from './pending.svg'
import HomeLogin from './HomeLogin.png'
import CheckmarkIcon from './checkmarkIcon.svg'
import UserIcon from './userIcon.svg'
import AlReadyPosp from './AlReadyPosp.svg'
import NewPosp from './NewPosp.svg'
import FileIcon from './fileIcon.svg'
import FinalVerificationIcon from './finalVerificationIcon.svg'
import CheckmarkDarkIcon from './checkmarkDark.svg'
import FailureIcon from './Failure.svg'
import SucceedIcon from './Succeed.svg'
import ZopperLogo from './zopperLogo.png'
import ZopperWhiteLogo from './zopperWhiteLogo.png'
import HomeLoginNew from './homeLoginNew.png'

export const PospImages = {
  BulkUploadFile,
  CorrectIcon,
  AddressProofIcon,
  ChequeIcon,
  PanIcon,
  PassportIcon,
  EducationIcon,
  ActiveIcon,
  CompletedIcon,
  RejectedIcon,
  PendingIcon,
  HomeLogin,
  CheckmarkIcon,
  UserIcon,
  AlReadyPosp,
  NewPosp,
  FileIcon,
  FinalVerificationIcon,
  CheckmarkDarkIcon,
  FailureIcon,
  SucceedIcon,
  ZopperLogo,
  ZopperWhiteLogo,
  HomeLoginNew
}
